/**
 * Wedev modified: Sibling Navigation Optimization
 * Uses window.location.replace to swap the URL without adding to browser history.
 * This ensures the 'Back' button returns to the collection/home page, not the previous color.
 */
(function() {
  // Run logic once DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Select all sibling links
    var links = document.querySelectorAll('.product__siblings .sibling__link');

    links.forEach(function(link) {
      // Use 'true' (Capture Phase) to intercept the click BEFORE theme.js or other scripts
      link.addEventListener('click', function(e) {
        
        // 1. Respect user intent: Allow opening in new tab with Ctrl/Cmd/Shift
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        // 2. Prevent the default browser navigation (which adds a history entry)
        e.preventDefault();
        e.stopPropagation(); // Stop other scripts from interfering

        // 3. The Magic: Replace the current history entry with the new URL
        // This swaps "Red Product" with "Blue Product" in the history stack
        var targetUrl = link.getAttribute('href');
        if (targetUrl) {
          window.location.replace(targetUrl);
        }
        
      }, true); 
    });
  });
})();

